// created_time et updated_time : lus sur le nodeData (`_creationTime`,
// `updatedAt`), jamais stockés ni écrits.

import { z } from "zod";
import { fail, type FieldKind } from "../kind";
import { dayInZone } from "../time";
import { dateDisplaySettings, dayOperators, formatPoint } from "./date";
import type { FieldSettingsMap, FormatCtx, RowMeta } from "../types";

const systemTimeSettings = z.object({
  includeTime: z.boolean().default(true),
  ...dateDisplaySettings,
});

export const createdTimeSettings = systemTimeSettings;
export const updatedTimeSettings = systemTimeSettings;

type SystemTimeSettings = FieldSettingsMap["created_time"];

function toPoint(epoch: number, settings: SystemTimeSettings, ctx: { timeZone: string }): string {
  return settings.includeTime
    ? new Date(epoch).toISOString()
    : dayInZone(epoch, settings.timeZone ?? ctx.timeZone);
}

function systemTimeKind<T extends "created_time" | "updated_time">(
  type: T,
  read: (meta: RowMeta) => number,
): FieldKind<T> {
  return {
    type,
    settings: systemTimeSettings,
    value: z.number(),
    readOnly: true,
    compute: (meta) => read(meta),
    coerce: () => fail("This field is computed and cannot be written."),
    format: (value, settings, ctx: FormatCtx) =>
      formatPoint(toPoint(value, settings, ctx), settings, ctx),
    compare: (a, b) => a - b,
    filters: dayOperators<T>((value) => new Date(value).toISOString()),
    aggregates: ["count", "earliest", "latest", "range"],
    toNumber: (value) => value,
  } as FieldKind<T>;
}

export const createdTimeKind = systemTimeKind("created_time", (meta) => meta.creationTime);
export const updatedTimeKind = systemTimeKind("updated_time", (meta) => meta.updatedAt);
